import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
export const BounceHousePackages = () => {
  const packages = [{
    id: '01',
    name: 'Small Bounce House',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kHTQ5jrXVC67yJtPhD7f1i/image.png',
    description: 'A perfect fit for smaller spaces, this colorful bounce house offers a safe and fun environment for toddlers to jump, play, and explore.',
    features: ['Compact size for smaller spaces', 'Colorful design with green, red, blue, and yellow', 'Slide for added fun', 'Safe for toddlers and young children', 'Easy setup and takedown'],
    price: '$90 / day'
  }, {
    id: '02',
    name: 'Medium Bounce House',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5tTgeW9u1Enn5ocNJKzxWn/81UlUFMHYOL._AC_SL1500_-1024x648.jpg',
    description: "This bounce house offers more space and a larger slide than the small option, providing a bit more excitement for toddlers. With its colorful design and spacious play area, it's great for kids who are ready for a bit more adventure",
    features: ['Medium size - perfect for backyard parties', 'Yellow, red, and blue color scheme', 'Wide slide for easy access', 'Spacious jumping area', 'Suitable for multiple children'],
    price: '$100 / day'
  }, {
    id: '03',
    name: 'Combo Bounce House',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gHRpHpQ744Tqwj57J7go3N/image.png',
    description: 'A larger option, this vibrant bounce house features a spacious play area filled with multicolored balls. Ideal for bigger groups of little ones, offering endless fun and laughter.',
    features: ['Combo design with ball pit and slide', 'Vibrant, colorful appearance', 'Larger size for more play space', 'Multicolored balls included', 'Perfect for bigger events'],
    price: '$125 / day'
  }, {
    id: '04',
    name: 'Medium White Bounce House',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vnJ8Vsi2yVGyEnBLbZNqzj/image.png',
    description: "With it's soft white design it provides an upscale experience while ensuring plenty of space for toddlers to jump, play, and enjoy. Perfect for those looking to add a touch of luxury to their event.",
    features: ['Elegant all-white design', 'Medium size for versatile placement', 'Clean, modern aesthetic', 'Perfect for upscale events', 'Complements any party décor'],
    price: '$150'
  }, {
    id: '05',
    name: 'Combo White Bounce House',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rDecq4r6w9CqRJodkYNa3L/0C7B1578-7567-45F8-8CC7-AC72C34BAC1E-768x1024.jpg',
    description: 'Featuring a premium white design, large slide, and ball pit, this bounce house provides immense fun for your adventurous toddlers, while keeping the party classy!',
    features: ['Premium white design', 'Includes ball pit and curved slide', 'Perfect for luxury events', 'Accommodates multiple children'],
    price: '$200'
  }, {
    id: '06',
    name: 'Mega White Combo Bounce House',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/42dN8ZAPRjx3pURCvvrteu/image.png',
    description: 'Our largest and most impressive bounce house! This stunning premium white castle design features elegant towers and spacious interior, perfect for creating an unforgettable luxury experience for your little ones.',
    features: ['Largest bounce house in our collection', 'Premium white castle design with towers', 'Spacious interior for maximum play', 'Elegant and sophisticated appearance', 'Perfect for upscale celebrations', 'Accommodates larger groups'],
    price: '$250'
  }];
  return <div className="bg-white w-full" data-id="element-352">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-353">
        {/* Page Title Section */}
        <div className="text-center mb-16" data-id="element-354">
          <h1 className="text-4xl md:text-5xl font-bold text-primary-500 leading-tight" data-id="element-355">
            Discover Our Fleet Of Bounce Houses
          </h1>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-356">
            We offer a variety of bounce houses designed to bring your vision to
            life and create memorable, one-of-a-kind experiences for little
            ones!
          </p>
        </div>
        {/* Package Cards Section */}
        <div className="space-y-8" data-id="element-357">
          {packages.map(pkg => <div key={pkg.id} className="bg-white rounded-3xl shadow-lg overflow-hidden border border-gray-100" data-id="element-358">
              <div className="flex flex-col md:flex-row" data-id="element-359">
                {/* Package Image */}
                <div className="md:w-2/5" data-id="element-360">
                  <img src={pkg.image} alt={`${pkg.name}`} className={`w-full h-full ${pkg.id === '01' ? 'object-cover object-center' : pkg.id === '05' ? 'object-cover object-center' : 'object-contain bg-gray-50'}`} data-id="element-361" />
                </div>
                {/* Package Details */}
                <div className="p-8 md:w-3/5 flex flex-col h-full" data-id="element-362">
                  <div className="flex-grow" data-id="element-363">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-364">
                      <span className="text-primary-500" data-id="element-365">{pkg.id}</span> -{' '}
                      {pkg.name}
                    </h2>
                    <p className="text-gray-600 mb-6" data-id="element-366">{pkg.description}</p>
                    <ul className="space-y-3" data-id="element-367">
                      {pkg.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-368">
                          <CheckIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-369" />
                          <span data-id="element-370">{feature}</span>
                        </li>)}
                    </ul>
                  </div>
                  <div className="mt-auto pt-6 text-center border-t border-gray-100" data-id="element-371">
                    <span className="text-4xl font-bold text-green-800" data-id="element-372">
                      {pkg.price}
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        {/* Call to Action */}
        <div className="mt-16 text-center" data-id="element-373">
          <Link to="/contact" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-secondary-500 hover:bg-secondary-600 transition" data-id="element-374">
            Book Your Bounce House
          </Link>
        </div>
      </div>
    </div>;
};